import { useEffect, useState } from 'react'
import { useTranslation } from '../helpers/i18n/useTranslation';

type DeviceType = 'android' | 'ios' | 'desktop';

export default function DeepLinkRedirect() {
  const [deviceType, setDeviceType] = useState<DeviceType | ''>('')
  const { translate, locale } = useTranslation();

  useEffect(() => {
    const userAgent = navigator.userAgent

    if (/android/i.test(userAgent)) {
      setDeviceType('android')
      window.location.href = 'https://play.google.com/store/apps/details?id=com.routethis.techhelp'
    } else if (/iPhone|iPad/i.test(userAgent)) {
      setDeviceType('ios')
      window.location.href = 'https://apps.apple.com/ca/app/routethis-certify/id1586154878'
    } else {
      setDeviceType('desktop')
    }
  }, [])

  if (deviceType === 'desktop') {
    return (
      <div>
        <p>{translate('desktop_deeplink_redirect')}</p>
      </div>
    )
  }
  if (deviceType === 'android' || deviceType === 'ios') {
    return (
    <div>
      <p>{translate('mobile_deeplink_redirect_1')}</p>
      <br />
      <p>{translate('mobile_deeplink_redirect_2')}</p>
    </div>
    )
  }

  return null
}